
<script setup>

  import { ArrowLeftCircleIcon } from '@heroicons/vue/24/outline';

  import backgroundPath from '../images/distressed-background.jpg';

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="p-6">

        <div class="max-w-md">

          <h2 class="pb-6 border-b-[3px] border-black">

            <div class="text-xl tracking-narrow font-semibold uppercase">Activity 5</div>

            <div class="text-4xl md:text-5xl font-heading uppercase">Completed!</div>

          </h2>

          <p class="mt-8 leading-7 text-neutral-700">

            You have completed <strong>Activity 5: Telling the Whole Story</strong>.

          </p>

          <p class="mt-8 leading-7 text-neutral-700">

            Thank you for taking the time to learn about the history of Lewis Mountain and experience it through some of the people who lived it.

          </p>

        </div>

        <div class="flex justify-between gap-6 mt-12">

          <RouterLink

            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                
              hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"
          
            to="/activities">
            
            <ArrowLeftCircleIcon class="w-8" />

            <span>Main Menu</span>
          
          </RouterLink>

        </div>

      </div>

    </div>

  </article>

</template>
